import type { Context } from "configureStore";
import makeDebug from "debug";
import {
	all,
	call,
	fork,
	getContext,
	put,
	takeEvery,
} from "redux-saga/effects";
import {
	getReportCommentsError,
	type getReportCommentsRequest,
	getReportCommentsSuccess,
	type getSharedReportCommentsRequest,
} from "./actions";
import { ReportCommentsActionTypes } from "./types";

const debug = makeDebug("store:reports:saga");

// LOAD SHARED REPORT COMMENTS
function* handleGetSharedReportCommentsRequest(
	action: ReturnType<typeof getSharedReportCommentsRequest>,
) {
	debug("handle get report results", action);
	const api: Context["api"] = yield getContext("api");
	try {
		const { data } = yield call(
			api.get,
			`/public/shared-report/comment-result/${action.payload.resultId}`,
			{
				params: {
					accessToken: action.payload.accessToken,
					segmentPath: action.payload.segmentPath,
					limit: action.payload.limit,
					skip: action.payload.skip,
					groupBy: action.payload.groupBy,
				},
			},
		);
		yield put(
			getReportCommentsSuccess(
				action.payload.requestId,
				action.payload.segmentPath || "GLOBAL",
				data,
			),
		);
	} catch (err) {
		yield put(getReportCommentsError(action.payload.requestId, err));
	}
}

function* watchGetSharedReportCommentsRequest() {
	yield takeEvery(
		ReportCommentsActionTypes.GET_SHARED_REPORT_COMMENTS_REQUEST,
		handleGetSharedReportCommentsRequest,
	);
}

// LOAD REPORT Results
function* handleGetReportCommentsRequest(
	action: ReturnType<typeof getReportCommentsRequest>,
) {
	debug("handle get report results", action);
	const api: Context["api"] = yield getContext("api");
	try {
		const { data } = yield call(
			api.get,
			`/organizations/${action.payload.organizationId}/reports/${action.payload.reportId}/comment-result/${action.payload.resultId}`,
			{
				params: {
					segmentPath: action.payload.segmentPath,
					limit: action.payload.limit,
					skip: action.payload.skip,
					groupBy: action.payload.groupBy,
				},
			},
		);
		yield put(
			getReportCommentsSuccess(
				action.payload.requestId,
				action.payload.segmentPath || "GLOBAL",
				data,
			),
		);
	} catch (err) {
		yield put(getReportCommentsError(action.payload.requestId, err));
	}
}

function* watchGetReportCommentsRequest() {
	yield takeEvery(
		ReportCommentsActionTypes.GET_REPORT_COMMENTS_REQUEST,
		handleGetReportCommentsRequest,
	);
}

function* reportCommentsSaga() {
	yield all([
		fork(watchGetReportCommentsRequest),
		fork(watchGetSharedReportCommentsRequest),
	]);
}

export default reportCommentsSaga;
